/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { Industry } from '../models/Industry';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable()
export class IndustryService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @returns Industry Success
     * @throws ApiError
     */
    public getAllIndustries(): Observable<Array<Industry>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/industry/get-all-industries',
        });
    }

}
